import { useLocalSearchParams } from 'expo-router';
import { Platform } from 'react-native';

import { PeopleScreen } from '@/components/domain/members/PeopleScreen';
import { peopleListTypes, type PeopleListType } from '~/constants/lists';
import { createEmptySearchCardV6, parseSearchCardFromParams } from '~/models/SearchCardV6';

function parseFromParam(from: unknown): PeopleListType {
  if (typeof from !== 'string' || from === 'search') return 'online';
  return (peopleListTypes as readonly string[]).includes(from)
    ? (from as PeopleListType)
    : 'online';
}

export default function PeopleSearchResultsScreen() {
  const params = useLocalSearchParams();

  // Parse search card from URL params (web only)
  const initialSearchCard =
    Platform.OS === 'web' ? (parseSearchCardFromParams(params) ?? createEmptySearchCardV6()) : null;

  const lastUsedListType = parseFromParam(params.from);

  return (
    <PeopleScreen
      listType="search"
      initialSearchCard={initialSearchCard}
      lastUsedListType={lastUsedListType}
    />
  );
}
